import React, { useMemo } from 'react';

import { Reconnect } from 'src/federation/Reconnect';

import { getServiceSalesReportTableProps } from './serviceSalesReportTableProps';

const ReportTable = ({ rows, total }) => {
  const props = useMemo(() => getServiceSalesReportTableProps({ rows, total }), [rows, total]);

  return <Reconnect name="ReportTable" props={props} />;
};

export default ReportTable;
